import type { PendingSignaturePlacementDto } from '@dealstack/shared/lib/generated';
import { boxesOverlap } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/MasterDocuments/components/SignaturePlacement/PlacementCanvas/placementCollision.utils';

/** True when two boxes share a spot on one page. Checked at send, which every exit from the editor reaches. */
export const hasOverlappingPendingPlacements = (
	placements: PendingSignaturePlacementDto[]
): boolean =>
	placements.some((placement, index) =>
		placements
			.slice(index + 1)
			.some((other) => other.pageNum === placement.pageNum && boxesOverlap(placement, other))
	);
